import { render, staticRenderFns } from "./PopupAddDataController.vue?vue&type=template&id=bb23dc36&scoped=true&"
import script from "./PopupAddDataController.vue?vue&type=script&lang=js&"
export * from "./PopupAddDataController.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb23dc36",
  null
  
)

export default component.exports